import { toast } from '@qse/ui'
import { useMutation, useQuery } from '@tanstack/react-query'

import { deleteCurrentApiKey, generateApiKey, getCurrentApiKey } from '../api-key'
import { queryKeys, queryOptions } from '../react-query-config'

export const useCurrentApiKey = (options?: { enabled?: boolean }) => {
  const { enabled, ...restOptions } = options || {}

  return useQuery({
    queryKey: queryKeys.apiKeys.current(),
    queryFn: getCurrentApiKey,
    enabled: enabled !== false, // Default to true if not specified
    ...queryOptions.apiKeys, // Use specific API keys query options
    ...restOptions,
  })
}

export const useGenerateApiKey = () => {
  return useMutation({
    mutationFn: generateApiKey,
    onSuccess: () => {
      // Invalidate current API key query to refresh the data
      toast.success('API key generated successfully')
    },
    onError: () => {
      toast.error('Failed to generate API key. Please try again.')
    },
  })
}

export const useDeleteCurrentApiKey = () => {
  return useMutation({
    mutationFn: deleteCurrentApiKey,
    onSuccess: () => {
      toast.success('API key deleted successfully')
    },
    onError: () => {
      toast.error('Failed to delete API key. Please try again.')
    },
  })
}
